import { SimpleTable, TableActions } from '@core/components/Table';
import { TableActionButtonDelete, TableActionButtonEdit } from '@core/components/TableAction';
import TableActionContainer from '@core/components/TableAction/TableActionContainer';
import { useReduxLoading, useReduxMessage } from '@core/hooks';
import { permissaoUtils } from '@core/util/permissaoUtil';
import { formatCNPJ, formatCPF, formatTELEFONE } from '@format';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import React from 'react';
import { FaCloudDownloadAlt } from 'react-icons/fa';
import { FornecedorActions } from '../../store/fornecedorAction';
import { useFornecedor } from '../../store/fornecedorContext';
import Locale from '../i18n/pt-br';

const exibirCpfCnpj = (rowData) => {
  if (rowData.pessoa) {
    if (rowData.pessoa.pessoaFisica) {
      return formatCPF(rowData.pessoa.pessoaFisica.cpf);
    }
    if (rowData.pessoa.pessoaJuridica) {
      return formatCNPJ(rowData.pessoa.pessoaJuridica.cnpj);
    }
  }
};

const FornecedoresTable = ({ onTour, onFetchData }) => {
  const [state, dispatch] = useFornecedor();

  const { message, page, selecionados, carregandoRegistro, carregandoRegistros, filtroAvancado } = state;

  useReduxLoading(carregandoRegistro);

  useReduxMessage(message);

  const columns = [
    {
      name: 'pessoa.nome',
      title: Locale.tabela.nome,
      getCellValue: (data) => data.pessoa.nome,
      sortingEnabled: true,
    },
    {
      name: 'pessoa.pessoaJuridica.razaoSocial',
      title: Locale.tabela.razaoSocial,
      allowSorting: false,
      getCellValue: (data) => {
        if (data.pessoa)
          return data.pessoa.pessoaJuridica && data.pessoa.pessoaJuridica.razaoSocial
            ? data.pessoa.pessoaJuridica.razaoSocial
            : '-';
      },
      sortingEnabled: true,
    },
    {
      name: 'pessoa.tipoPessoa' === 'pessoaJuridica' ? 'pessoa.pessoaJuridica.cnpj' : 'pessoa.pessoaFisica.cpf',
      title: Locale.tabela.cpfCnpj,
      allowSorting: false,
      getCellValue: exibirCpfCnpj,
      sortingEnabled: true,
    },
    {
      name: 'pessoa.contatos.numero',
      title: Locale.tabela.telefone,
      allowSorting: false,
      getCellValue: (data) => {
        if (data.pessoa) {
          const numero = data.pessoa.contatos && data.pessoa.contatos[0] && data.pessoa.contatos[0].numero;

          if (numero) {
            return formatTELEFONE(numero);
          }
        }
        return '-';
      },
      sortingEnabled: true,
    },
    {
      name: '',
      title: '',
      sortingEnabled: false,
      align: 'left',
      width: 125,
      getCellValue: (fornecedor) => (
        <>
          <TableActionContainer onTour={onTour}>
            {permissaoUtils.fornecedor().editar && !fornecedor.locked && (
              <TableActionButtonEdit
                className={'stepIconeEditar'}
                onClick={() => FornecedorActions.requestEditar(dispatch, [fornecedor.id])}
              />
            )}

            {permissaoUtils.fornecedor().excluir && !fornecedor.locked && (
              <TableActionButtonDelete
                className={'stepIconeExcluir'}
                onClick={() => FornecedorActions.excluirFornecedores(dispatch, [fornecedor.id], null)}
              />
            )}
          </TableActionContainer>
        </>
      ),
    },
  ];

  const deleteRow = () => {
    FornecedorActions.excluirFornecedores(
      dispatch,
      selecionados.map((s) => s.id),
      state.tipoSelecao === 'TODOS_FILTRO',
      state.requestParams
    );
  };

  const onSelectRow = (row) => {
    if (row) {
      FornecedorActions.requestVisualizar(dispatch, row.id);
    }
  };

  const actions = [
    {
      icon: <DeleteIcon />,
      name: 'excluir',
      tooltip: Locale.acao.excluir,
      show:
        permissaoUtils.fornecedor().excluir &&
        (state.tipoSelecao === 'TODOS_FILTRO' || (state.selecionados && state.selecionados.length > 0)),
      onClick: deleteRow,
    },
    {
      icon: <FaCloudDownloadAlt />,
      name: 'importar',
      tooltip: Locale.acao.importar,
      show: permissaoUtils.fornecedor().cadastrar,
      onClick: () => FornecedorActions.abrirImportModal(dispatch),
    },
    {
      icon: <AddIcon />,
      name: 'cadastrar',
      tooltip: Locale.acao.cadastrar,
      show: permissaoUtils.fornecedor().cadastrar,
      onClick: () => dispatch(FornecedorActions.cadastrar()),
    },
  ];

  const onSelectionChange = (params) => dispatch(FornecedorActions.setSelecionados(params));

  const onCurrentPageChange = (params) => {
    dispatch(FornecedorActions.setCurrentPage(params));
  };

  const onPageSizeChange = (params) => dispatch(FornecedorActions.setPageSize(params));
  const onSortingChange = (params) => dispatch(FornecedorActions.setSorting(params));

  return (
    <>
      <SimpleTable
        // fetchOnCreate
        defaultSorting={[{ columnName: 'pessoa.nome', direction: 'asc' }]}
        columns={columns}
        rows={page?.content}
        selection={selecionados}
        loading={carregandoRegistros}
        totalCount={state.page?.totalElements}
        searchBy={state.requestParams?.q}
        fetchData={onFetchData}
        onRowClick={onSelectRow}
        onSelectionChange={onSelectionChange}
        onCurrentPageChange={onCurrentPageChange}
        onPageSizeChange={onPageSizeChange}
        onSortingChange={onSortingChange}
        selectionType={state.tipoSelecao}
        params={filtroAvancado}
        contemFiltroAvancado
        onSelectionTypeChange={(params) => {
          dispatch(FornecedorActions.setTipoSelecao(params));
        }}
      />
      {(permissaoUtils.fornecedor().cadastrar ||
        permissaoUtils.fornecedor().excluir ||
        permissaoUtils.fornecedor().editar) && <TableActions className={'stepPlusButton'} actions={actions} />}
    </>
  );
};

export default FornecedoresTable;
